class UpgradeInfoComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <div id="upgrade-info">
        <div class="row mt-3" style="max-width: 900px;">
          <div class="card">
            <div class="card-body">
              <h3>Finish your projects faster with WebStructural <a href="#" data-toggle="modal"
                  data-target="#modal-sign-up-form">Upgrade now</a></h3>
            </div>
          </div>
        </div>

        <div class="row mt-3" style="max-width: 900px;">
          <a href="beam-designer.html" style="text-decoration: none; color:inherit;">
            <div class="col">
              <div class="card">
                <div class="card-body">
                  <img src="./images/new-home/complex-beam-screenshot.png" width="300px">
                  <div class="float-start">
                    <h3>Multi-span Beam Design</h3>
                    <p class="lead">Design multi-span beams with complex loads with WebStructural's intuitive
                      interface. An interactive drawing area allows you to design complex, multi-span beams in minutes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
          
        <div class="row mt-3" style="max-width: 900px;">
          <a href="beam-designer.html" style="text-decoration: none; color:inherit;">
            <div class="col">
              <div class="card">
                <div class="card-body">
                  <img src="./images/new-home/report-screenshot.png" width="300px">
                  <div class="float-start">
                    <h3>Comprehensive Reports</h3>
                    <p class="lead">Easy to read, printable and comprehensive design reports.
                      AISC 360-16 Steel and NDS Wood Design LRFD and ASD Design Checks and Load Combinations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      `
  }
}

customElements.define('upgrade-info', UpgradeInfoComponent)